import { createClient } from "@supabase/supabase-js";
import type { Database } from "../types/supabase";

// These will be populated when connecting to Supabase
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);

export type Tables = Database["public"]["Tables"];
export type Student = Tables["students"]["Row"];
export type InsertStudent = Tables["students"]["Insert"];
export type UpdateStudent = Tables["students"]["Update"];

export type Series = Database["public"]["Tables"]["series"]["Row"];
export type InsertSeries = Database["public"]["Tables"]["series"]["Insert"];
export type UpdateSeries = Database["public"]["Tables"]["series"]["Update"];

export type Lab = {
  id: string;
  created_at: string;
  series_id: string;
  title: string;
  description: string | null;
  order_number: number;
  learning_outcomes: string[];
  mindfulness_topic: string | null;
  coding_topic: string | null;
  objective: string | null;
  resources: LabResource[];
};

export type InsertLab = Omit<Lab, "id" | "created_at">;

export type LabResource = {
  id: string;
  created_at: string;
  lab_id: string;
  type: "url" | "file";
  title: string;
  url?: string | null;
  file_path?: string | null;
  file_name?: string | null;
  file_type?: string | null;
};

export type InsertLabResource = Omit<LabResource, "id" | "created_at">;

export type Run = Database["public"]["Tables"]["runs"]["Row"];
export type InsertRun = Database["public"]["Tables"]["runs"]["Insert"];
export type UpdateRun = Database["public"]["Tables"]["runs"]["Update"];

export type Payment = Database["public"]["Tables"]["payments"]["Row"];
export type InsertPayment = Database["public"]["Tables"]["payments"]["Insert"];
export type UpdatePayment = Database["public"]["Tables"]["payments"]["Update"];

export type Enrollment = Database["public"]["Tables"]["enrollments"]["Row"];
export type InsertEnrollment =
  Database["public"]["Tables"]["enrollments"]["Insert"];
export type UpdateEnrollment =
  Database["public"]["Tables"]["enrollments"]["Update"];
